import React, {useEffect, useRef, useState} from "react";
import {
    Button,
    Checkbox,
    Col,
    Divider,
    Form,
    Input,
    message,
    Modal,
    Radio,
    Row,
    Space,
    Spin,
    Switch,
    Tooltip,
    Typography
} from "antd";
import './style.scss'
import signupService from "../../service/signupService";
import {InputDropdownParameterDto} from "../../dto/InputDropdownParameterDto";
import {
    COMMON_DROPDOWN,
    EMAIL_MAX_LENGTH,
    EMAIL_VALIDATION,
    IDENTIFICATION_SOURCE,
    MOBILE_NUMBER_MAX_LENGTH,
    MOBILE_NUMBER_MIN_LENGTH,
    NIC_VALIDATION,
    OTP_DESTINATION_TYPE,
    PARAMETER_LIST,
    PASSWORD_VALIDATION, PREVIEW_DOC_TYPES,
    USERNAME_VALIDATION
} from "../../util/Constants";
import {DropdownListDto} from "../../dto/DropdownListDto";
import {toLower} from "lodash";
import {UserMstDto} from "../../dto/UserMstDto";
import Validation from "../../util/Validation";
import {OtpRequestDto} from "../../dto/OtpRequestDto";
import {ValidateOtpDto} from "../../dto/ValidateOtpDto";
import {OtpDataDto} from "../../dto/OtpDataDto";
import {useKeycloak} from "@react-keycloak/web";
import {
    CheckCircleOutlined,
    DownloadOutlined,
    ExclamationCircleOutlined,
    QuestionCircleOutlined
} from "@ant-design/icons";
import {InputOTP} from "antd-input-otp";
import ErrorHandler from "../../util/ErrorHandler";
import PhoneInput, {CountryData} from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import {
    MSG_ENTER_REFERENCE_NUMBER,
    MSG_ENTER_USERNAME,
    MSG_FAILED_TO_FETCH_ACKNOWLEDGEMENT_DOCUMENT_ERROR,
    MSG_FAILED_TO_FETCH_AGREEMENTS_ERROR,
    MSG_FAILED_TO_FETCH_IDENTIFICATION_SOURCE_TYPES_ERROR,
    MSG_INVALID_REFERENCE,
    MSG_OTP_IS_INVALID,
    MSG_OTP_SEND_FAILURE_ERROR,
    MSG_OTP_VERIFICATION_FAILURE_ERROR,
    MSG_OTP_VERIFICATION_SUCCESS,
    MSG_PLEASE_CONSENT_TO_THE_ABOVE_AGREEMENTS,
    MSG_PLEASE_ENTER_A_VALID_EMAIL,
    MSG_REFERENCE_VALIDATION_FAILURE_ERROR,
    MSG_USER_CREATED_SUCCESS,
    MSG_USER_CREATION_FAILURE,
    MSG_USERNAME_ALREADY_TAKEN,
    MSG_USERNAME_VALIDATION_FAILURE_ERROR,
    MSG_VERIFY_YOUR_EMAIL_WARN,
    MSG_VERIFY_YOUR_MOBILE_NUMBER_AND_EMAIL_WARN,
    MSG_VERIFY_YOUR_MOBILE_NUMBER_WARN
} from "../../util/Messages";
import {useHistory} from "react-router-dom";
import {clearTimeout, setTimeout} from 'worker-timers';
import {load} from "worker-timers-broker";
import customerService from "../../service/customerService";
import modal from "antd/es/modal";
import {PageStep} from "../../enums/PageStep";
import documentService from "../../service/documentService";
import PreviewModalComp from "../common/preview/PreviewModalComp";
import { PhoneNumberUtil } from 'google-libphonenumber';
const TERMS_AND_CONDITIONS_DOCUMENT = "TERMS_AND_CONDITIONS_DOCUMENT";
const DECLARATION_DOCUMENT = "DECLARATION_DOCUMENT";
const SRI_LANKA_COUNTRY_CODE = "94";
const AccountCredential = () => {
    type otpInputType =
        "numeric"
        | "alphabet"
        | "symbol"
        | "alphabet-symbol"
        | "alphabet-numeric"
        | "numeric-symbol"
        | "all";
    const otpApplicationId: string | undefined = process.env.OTP_APPLICATION_ID ? process.env.OTP_APPLICATION_ID : "";
    const redirectUri: string | undefined = process.env.REDIRECT_URI ? process.env.REDIRECT_URI : "http://localhost:3000";
    let history = useHistory();
    const {keycloak} = useKeycloak();

    const otpFormRef: React.RefObject<HTMLFormElement> = React.createRef();
    const formRef: React.RefObject<HTMLFormElement> = React.createRef();
    const [agreementList, setAgreementList] = useState<DropdownListDto[]>([]);
    const [form] = Form.useForm();

    const [dropdownDto, setDropdownDto] = useState<DropdownListDto | undefined>({label: "NIC", value: 1});
    const [identificationSourceTypeList, setIdentificationSourceTypeList] = useState<DropdownListDto[]>([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isExistingUserModalOpen, setExistingUserModalOpen] = useState(false);
    const [isAgreementModalLoading, setAgreementModalLoading] = useState(false);
    const [isResendDisable, setIsResendDisable] = useState(true);
    const [isOtpVerified, setIsOtpVerified] = useState(false);
    const [isEmailOtpVerified, setEmailOtpVerified] = useState(false);
    const [emailVerified, setIsEmailVerified] = useState(false);
    const [mobileNoVerifiedStatus, setMobileNoVerifiedStatus] = useState(false);
    const [otpData, setOtpData] = useState<OtpDataDto>({
        message: "",
        otpRef: "",
        refId: "",
        retryCount: 0,
        tokenLength: 6,
        validityPeriod: 120,
        resendPeriod: 120,
        tokenType: "numeric",
    });
    const [emailAndMobileNo, setEmailAndMobileNo] = useState({email: "", phoneNo: ""});
    const [, setSavedUser] = useState<UserMstDto>({
        email: "",
        id: 0,
        identificationSourceType: 0,
        identificationSourceValue: "",
        password: "",
        phoneNo: "",
        pinNo: 0,
        userName: "",
        userStatus: ""
    });
    const [otpDestination, setOtpDestination] = useState({type: "", destination: "", maskedDestination: ""});
    const [timer, setTimer] = useState("");
    const [isMobileNoVerifyDisabled, setMobileNoVerifyDisabled] = useState(true);
    const [isEmailVerifyDisabled, setEmailVerifyDisabled] = useState(true);
    const [isMobileVerified, setMobileVerified] = useState(false);
    const [isEmailVerified, setEmailVerified] = useState(false);
    const [isConfirmPasswordDisabled, setConfirmPwDisabled] = useState(true);
    const [value, setValue] = useState([]);
    const [isSpinnerLoad, setIsSpinnerLoad] = useState(false);
    const [dialCode, setDialCode] = useState(SRI_LANKA_COUNTRY_CODE);
    const [countryCode, setCountryCode] = useState("lk");
    const [isBtnContinueLoad, setBtnContinueLoad] = useState(false);
    const [isReferencePresent, setReferencePresent] = useState(false);
    const [modalTitle, setModalTitle] = useState("");
    const [userFormData, setUserFormData] = useState<any>();
    const [documentName, setDocumentName] = useState<string>()
    const [docURL, setDocURL] = useState('');
    const [docType, setDocType] = useState<PREVIEW_DOC_TYPES>(PREVIEW_DOC_TYPES.IMAGE);
    const [showModalComp, setShowModalComp] = useState<boolean>(false)
    const [isForeignUser, setForeignUser] = useState<boolean>(false)
    const btnDownload = useRef<HTMLAnchorElement>(null)
    const [maxLengthOfContactNumber, setMaxLengthOfContactNumber] = useState<number>(9)
    const [countryCodeLength, setCountryCodeLength] = useState<number>(2)
    const accountTypePage = "/account-type-selection";
    const dashboardPage = "/workflow/customer/dashboard";

    const timeoutRef = useRef<load>();


    useEffect(() => {
        onLoad();
    }, [])

    const onLoad = () => {
        loadIdentitySourceTypes();

    }
    const onDownload = () => {
        btnDownload.current?.click();
    };

    const navigateAccordingToUser = (isExistingCustomer: boolean) => {
        if (keycloak && !keycloak.authenticated) {
            setIsSpinnerLoad(false)
            if (isExistingCustomer) {
                keycloak.login({redirectUri: `${redirectUri}${dashboardPage}`});
            } else {
                keycloak.login({redirectUri: `${redirectUri}${accountTypePage}`});
            }
        }
    }

    const getAgreementList = () => {

        const inputDropdownParameterDto: InputDropdownParameterDto = {
            dropdownDataSourceId: COMMON_DROPDOWN.AGREEMENT,
            findTextValue: "",
            parameterList: [[2], [PageStep.STEP_ACKNOWLEDGMENT_DETAIL], [PARAMETER_LIST.ACTIVE]]

        }
        customerService.getCommonDropdown(inputDropdownParameterDto).then(res => {
            if (res.data !== null) {
                let activeItemList = res.data.results.activeItemList;
                setAgreementList(activeItemList)
                setExistingUserModalOpen(true);
            } else {
                message.error(MSG_FAILED_TO_FETCH_AGREEMENTS_ERROR).then();
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
        })
    }
    const showModal = () => {
        setIsModalOpen(true);
    };

    const agreementModal = () => {
        getAgreementList()
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        countdown(false)
    };
    const handlePreviewCancel = () => {
        setShowModalComp(false);
    };

    const handleExistingUserModalCancel = () => {
        form.resetFields()
        setExistingUserModalOpen(false)
    };

    const validateAgreements = (rule: any, value: any, callback: any) => {


        if (undefined == value) {
            callback(MSG_PLEASE_CONSENT_TO_THE_ABOVE_AGREEMENTS)
        } else if (!agreementList.every((a: DropdownListDto) => value.includes(a.value as number))) {
            callback(MSG_PLEASE_CONSENT_TO_THE_ABOVE_AGREEMENTS)
        } else {
            callback()
        }
    };

    const onChange = (e: Event) => {
        formRef.current?.setFieldsValue({identificationSourceValue: undefined})
        let dropdownListDto = identificationSourceTypeList.find((obj: DropdownListDto) => {
            return obj.value == (e.target as HTMLInputElement).value
        });
        setDropdownDto(dropdownListDto)
    };


    const loadIdentitySourceTypes = () => {
        const inputDropdownParameterDto: InputDropdownParameterDto = {
            dropdownDataSourceId: COMMON_DROPDOWN.IDENTIFICATION_SOURCE,
            findTextValue: "",
            parameterList: [PARAMETER_LIST.ACTIVE]
        }
        signupService.getCommonDropdownList(inputDropdownParameterDto).then(res => {
            if (res.data !== null) {
                setIdentificationSourceTypeList(res.data.results.activeItemList)
            } else {
                message.error(MSG_FAILED_TO_FETCH_IDENTIFICATION_SOURCE_TYPES_ERROR).then();
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
        })
    }
    const onContinue = (user: any) => {
        if ((!isEmailOtpVerified) || (!isOtpVerified && !isForeignUser)) {
            if (!isOtpVerified && !isEmailOtpVerified && !isForeignUser) {
                message.warning(MSG_VERIFY_YOUR_MOBILE_NUMBER_AND_EMAIL_WARN);
            } else if (!isOtpVerified && !isForeignUser) {
                message.warning(MSG_VERIFY_YOUR_MOBILE_NUMBER_WARN);
            } else if (!isEmailOtpVerified) {
                message.warning(MSG_VERIFY_YOUR_EMAIL_WARN);
            }
        } else {
            modal.confirm({
                title: 'Confirm',
                icon: <ExclamationCircleOutlined/>,
                content: `Are you an existing customer?`,
                okText: 'Yes',
                cancelText: 'No',
                className: 'confirm-dialog-box',
                okButtonProps: {style: {background: '#FF7400'}},
                onOk() {
                    agreementModal();
                    user.phoneNo = getCleanedPhoneNumber(user.phoneNo);
                    setUserFormData(user)
                    // createUser(true, user);
                },
                onCancel() {
                    createUser(false, user, []);
                }
            });
        }
    }
    const getCleanedPhoneNumber = (phoneNumber: string) => {
        let replacedNumber = phoneNumber.replace(/\D/g, '');
        const maxLength = countryCodeLength + maxLengthOfContactNumber;

        return replacedNumber.length > maxLength ? replacedNumber.slice(0, maxLength) : replacedNumber
    }
    const createUser = (isExistingCustomer: boolean, user: UserMstDto, agreementIdList: number[]) => {
        setBtnContinueLoad(true)

        let userMstDto: UserMstDto = user;
        userMstDto.identificationSourceType = dropdownDto?.value as number;
        userMstDto.existingCustomer = isExistingCustomer;
        userMstDto.phoneNo = getCleanedPhoneNumber(user.phoneNo);
        userMstDto.agreementIdList = agreementIdList
        signupService.createUser(userMstDto).then((res: any) => {
            if (res.data !== null) {
                formRef.current?.resetFields();
                setIsSpinnerLoad(true)
                message.success(MSG_USER_CREATED_SUCCESS).then(() => {
                    setSavedUser(res.data.results)
                    navigateAccordingToUser(isExistingCustomer);
                });
            } else {
                message.error(MSG_USER_CREATION_FAILURE).then();
                setBtnContinueLoad(false)
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
            setBtnContinueLoad(false)
        })
    }
    const validateUsername = (rule: any, value: any, callback: any) => {
        if (value) {
            signupService.validateUsername(value).then(res => {
                if (res.data !== null) {
                    if (res.data.results) {
                        callback(MSG_USERNAME_ALREADY_TAKEN)

                    } else {
                        callback()
                    }
                } else {
                    message.error(MSG_USERNAME_VALIDATION_FAILURE_ERROR).then();
                    callback()
                }
            }, (reason) => {
                ErrorHandler.handleError(reason);
                callback()
            })
        } else {
            callback(MSG_ENTER_USERNAME)
        }
    };
    const validateReference = (rule: any, value: any, callback: any) => {
        if (value && value.length <= 6) {
            customerService.validateReferenceNumber(value).then(res => {
                if (res.data !== null) {
                    if (!res.data.results) {
                        callback(MSG_INVALID_REFERENCE)

                    } else {
                        callback()
                    }
                } else {
                    message.error(MSG_REFERENCE_VALIDATION_FAILURE_ERROR).then();
                    callback()
                }
            }, (reason) => {
                ErrorHandler.handleError(reason);
                callback()
            })
        } else {
            callback(MSG_ENTER_REFERENCE_NUMBER)
        }
    };

    const generateMobileOrEmail = (type: OTP_DESTINATION_TYPE | string) => {
        setIsSpinnerLoad(true)
        let destination = "";

        otpFormRef.current?.resetFields();
        setValue([])

        if (type == OTP_DESTINATION_TYPE.EMAIL) {
            destination = formRef.current?.getFieldValue("email");
            setEmailAndMobileNo({email: destination, phoneNo: ""})
            setModalTitle("EMAIL VERIFICATION")
        } else if (type == OTP_DESTINATION_TYPE.SMS) {
            destination = formRef.current?.getFieldValue("phoneNo").replaceAll(' ', '').replaceAll('+', "");
            setEmailAndMobileNo({email: "", phoneNo: destination})
            setIsOtpVerified(false);
            setModalTitle("MOBILE NUMBER VERIFICATION")
        }

        let otpRequestDto: OtpRequestDto = {
            userName: "",
            destinations: [{
                type: type,
                destination: destination
            }]
        }

        signupService.generateOtp(otpRequestDto).then((res: any) => {
            if (res.data !== null) {
                let otpData: OtpDataDto = res.data.results;
                setOtpData(otpData)
                setOtpDestination({
                    type: type,
                    destination: destination,
                    maskedDestination: maskEmailAndMobileNumber(destination)
                })
                showModal();
                countdown(true)
                setIsSpinnerLoad(false)
            } else {
                message.error(MSG_OTP_SEND_FAILURE_ERROR).then();
                setIsSpinnerLoad(false)

            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
            setIsSpinnerLoad(false)

        })
    }

    const countdown = (enable: boolean) => {
        let seconds = otpData.resendPeriod;
        setTimer("0:00")

        function tick() {
            const minutesRemaining = Math.floor(seconds / 60);
            const secondsRemaining = seconds % 60;
            --seconds;
            setTimer(`${minutesRemaining.toString().padStart(2, '0')}:${secondsRemaining.toString().padStart(2, '0')}`);
            if (seconds >= 0) {
                timeoutRef.current = setTimeout(tick, 1000);
                setIsResendDisable(true);
            } else {
                setIsResendDisable(false);
            }
        }

        if (enable) {
            tick()
        } else {
            if (typeof timeoutRef.current === "number") {
                clearTimeout(timeoutRef.current);
            }
        }
    }

    const maskEmailAndMobileNumber = (value: string) => {
        let isEmail = value.includes("@");
        let valueArr: string[];
        valueArr = value.split('');
        let finalArr: string[] = [];
        let len = value.indexOf('@') > -1 ? value.indexOf('@') : value.length - 2;
        if (isEmail) {
            valueArr.forEach((item: any, pos: number) => {
                (pos >= 1 && pos <= len - 2) ? finalArr.push('*') : finalArr.push(valueArr[pos]);
            })
            return finalArr.join('');
        } else {
            valueArr.forEach((item: any, pos: number) => {
                (pos <= len - 2) ? finalArr.push('*') : finalArr.push(valueArr[pos]);
            })
            return finalArr.join('');

        }
    }

    const validateOtp = () => {
        let userOtp = otpFormRef.current?.getFieldValue("userOtp");
        if (!userOtp || userOtp.includes(undefined) || userOtp.includes("") || userOtp.length != otpData.tokenLength) {
            return otpFormRef.current?.setFields([
                {
                    name: "userOtp",
                    errors: [MSG_OTP_IS_INVALID]
                }
            ]);

        } else {
            let validateOtpDto: ValidateOtpDto = {
                refId: otpData.refId,
                appId: otpApplicationId,
                otp: userOtp.join(''),
                otpRef: otpData.otpRef
            }
            signupService.validateOtp(validateOtpDto).then((res: any) => {
                if (res.data !== null && res.data.status == "SUCCESS") {
                    message.success(MSG_OTP_VERIFICATION_SUCCESS).then();
                    handleOk();
                    otpValidStatusCheck(true);
                    countdown(false)
                } else {
                    message.error(MSG_OTP_VERIFICATION_FAILURE_ERROR).then();
                    otpValidStatusCheck(false);
                }
            }, (reason) => {
                ErrorHandler.handleError(reason);
                otpValidStatusCheck(false);
            })
        }
    }

    const otpValidStatusCheck = (value: boolean) => {
        if (otpDestination.type == OTP_DESTINATION_TYPE.SMS) {
            setIsOtpVerified(value);
            setMobileVerified(value);
            setMobileNoVerifiedStatus(value);
        } else if (otpDestination.type == OTP_DESTINATION_TYPE.EMAIL) {
            setIsEmailVerified(value);
            setEmailVerified(value);
            setEmailOtpVerified(value)
        }
    }

    const [isValidPhoneNo, setIsValidPhoneNo] = useState(true);
    const validatePhoneNo = (_: any, valueTemp: any) => {
        const value = formRef.current?.getFieldValue("phoneNo")
        if (value) {
            const valueWithoutSpaces = value.replace(/\D/g, '')
            const phoneWithoutCountryCode = valueWithoutSpaces.replace(`${dialCode}`, '');
            if (phoneWithoutCountryCode.startsWith('0')) {
                setMobileNoVerifyDisabled(true)
                setIsValidPhoneNo(false)
                return Promise.reject("Mobile number cannot start with zero");
            } else if (valueWithoutSpaces.length < MOBILE_NUMBER_MIN_LENGTH) {
                setMobileNoVerifyDisabled(true)
                setIsValidPhoneNo(false)
                return Promise.reject("Minimum of 7 characters are required");
            } else if (valueWithoutSpaces.length > MOBILE_NUMBER_MAX_LENGTH) {
                setMobileNoVerifyDisabled(true)
                setIsValidPhoneNo(false)
                return Promise.reject("The maximum length is 15 numbers");
            } else {
                setMobileNoVerifyDisabled(false)
                setIsValidPhoneNo(true)
                return Promise.resolve();
            }
        } else {
            setMobileNoVerifyDisabled(true)
            setIsValidPhoneNo(false)
            return Promise.reject();
        }

    };
    const validateEmail = (_: any, value: any) => {
        if (!value || value.length > EMAIL_MAX_LENGTH) {
            setEmailVerifyDisabled(true)
            return Promise.reject();
        }
        if (!EMAIL_VALIDATION.test(value)) {
            setEmailVerifyDisabled(true)
            return Promise.reject(MSG_PLEASE_ENTER_A_VALID_EMAIL);
        } else {
            setEmailVerifyDisabled(false)
            return Promise.resolve();
        }

    };
    const validatePassword = (_: any, value: any) => {

        if (!value) {
            formRef.current?.resetFields(["confirm"])
            setConfirmPwDisabled(true)
            return Promise.reject("Please enter your password");
        }
        if (!PASSWORD_VALIDATION.test(value)) {
            formRef.current?.resetFields(["confirm"])
            setConfirmPwDisabled(true)
            return Promise.reject("Please enter a valid password");
        } else {
            setConfirmPwDisabled(false)
            return Promise.resolve();
        }

    };
    const onChangeMobileNo = (event: Event) => {
        // const replacedVal = ((event.target as HTMLInputElement).value).replaceAll(' ', '').replaceAll('+', "")
        // const replacedPhoneNumber = emailAndMobileNo.phoneNo.replaceAll(' ', '').replaceAll('+', "")
        const input = (event.target as HTMLInputElement).value;
        const replacedVal = input.replace(/\D/g, '');
        const replacedPhoneNumber = emailAndMobileNo.phoneNo.replace(/\D/g, '');
        if (replacedVal != replacedPhoneNumber) {
            setMobileVerified(false);
            setIsOtpVerified(false)
        } else {
            if (replacedVal == "" && replacedPhoneNumber == "") {
                setMobileVerified(false);
                setIsOtpVerified(false)
            } else if (mobileNoVerifiedStatus) {

                setMobileVerified(true);
                setIsOtpVerified(true)
            }
        }


    }
    const onChangeEmail = (event: Event) => {
        if ((event.target as HTMLInputElement).value != emailAndMobileNo.email) {
            setEmailVerified(false);
            setEmailOtpVerified(false);
        } else {
            if ((event.target as HTMLInputElement).value == "" && emailAndMobileNo.email == "") {
                setEmailVerified(false);
                setEmailOtpVerified(false);
            } else if (emailVerified) {
                setEmailVerified(true);
                setEmailOtpVerified(true);
            }
        }
    }
    const preventDefaultEvent = (e: Event) => {
        e.preventDefault()
        return false;
    }

    const onClickBack = () => {
        history.push('/')
    }

    const getPlaceHolderByIdentificationType = (identificationType: string | undefined) => {
        if (undefined != identificationType) {
            return IDENTIFICATION_SOURCE.NIC === identificationType ? identificationType : toLower(identificationType)
        }
        return "N/A"
    }

    const handlePhoneChange = (value: string, country: CountryData) => {
        const phoneUtil = PhoneNumberUtil.getInstance();
        const numberProto = phoneUtil.getExampleNumberForType(country.countryCode.toUpperCase(), 1);
        setMaxLengthOfContactNumber(numberProto.getNationalNumber().toString().length)
        setCountryCodeLength(numberProto.getCountryCode().toString().length)
        if (SRI_LANKA_COUNTRY_CODE !== country.dialCode) {
            setForeignUser(true)
        } else {
            setForeignUser(false)
        }
        if (dialCode != country.dialCode) {
            formRef.current?.resetFields(['phoneNo']);
            setDialCode(country.dialCode)
            setCountryCode(country.countryCode)
            setMobileNoVerifyDisabled(true)
        }
    };

    const onReferenceSwitchChange = (evt: boolean) => {
        setReferencePresent(evt)
        formRef.current?.resetFields(['jointReferenceNumber']);
    }

    const onAgree = (values: any) => {
        handleExistingUserModalCancel()
        createUser(true, userFormData, values.agreementList);
    }

    const showPreview = (value: {}) => {
        setAgreementModalLoading(true)
        let documentName = ""
        if (value == 3) {
            documentName = DECLARATION_DOCUMENT;
        } else if (value == 4) {
            documentName = TERMS_AND_CONDITIONS_DOCUMENT;
        }
        documentService.fetchAgreements([documentName]).then(res => {
            if (res.data !== null) {
                let result = res.data.results[0];
                setDocURL(result.thumbB64)
                setDocumentName(result.originalDocumentName)
                setShowModalComp(true)
                setDocType(PREVIEW_DOC_TYPES.PDF)
                setAgreementModalLoading(false)

            } else {
                setAgreementModalLoading(false)
                message.error(MSG_FAILED_TO_FETCH_ACKNOWLEDGEMENT_DOCUMENT_ERROR).then();
            }
        }, (reason) => {
            setAgreementModalLoading(false)
            ErrorHandler.handleError(reason);
        })

    }

    return (
        <>
            <Spin spinning={isSpinnerLoad} tip="Loading" size="large">
                <div className='account_credential_container'>
                    <h1 className='main-header'>Account Credentials</h1>
                    <h5 className='sub-header' style={{marginBottom: 20}}>Set account credentials for your account</h5>

                    <Form
                        className='form-input'
                        layout={"vertical"}
                        initialValues={{remember: true}}
                        onFinish={onContinue}
                        ref={formRef}
                    >
                        <Row gutter={[16, 0]}>
                            <Col xl={24} lg={24} md={24} sm={24} xs={24} className={"ant-col-xxl-12"}>
                                <Form.Item style={{marginBottom: 8}}>
                                    <Form.Item
                                        label={
                                            <>
                                                {
                                                    isMobileVerified ?
                                                        <>
                                                            Mobile Number <span style={{
                                                            color: 'green',
                                                            fontSize: 12,
                                                            paddingLeft: 8
                                                        }}>Verified </span> <CheckCircleOutlined
                                                            style={{color: 'green', fontSize: 10, padding: 3}}/>
                                                        </> :
                                                        <>Mobile Number</>
                                                }

                                            </>
                                        }
                                        name="phoneNo"
                                        // onKeyPress={Validation.isNumberWithoutDot}
                                        onChange={onChangeMobileNo}
                                        rules={[{required: true, message: 'Please enter your mobile number'},
                                            {validator: validatePhoneNo}

                                        ]}>
                                        <div style={{display: "flex"}}>
                                            <PhoneInput
                                                className={!isValidPhoneNo ? 'phone-error-border mobile_no_width  ' : 'phone-normal-border mobile_no_width  '}
                                                country={countryCode}
                                                enableSearch={true}
                                                countryCodeEditable={false}
                                                onChange={handlePhoneChange}
                                            />
                                            {!isMobileVerified && !isForeignUser ?
                                                <Button style={{width: 80, height: 40, marginLeft: 10}}
                                                        className={"otp_button_verify"}
                                                        disabled={isMobileNoVerifyDisabled}
                                                        type="link"
                                                        onClick={!isMobileNoVerifyDisabled ? () => generateMobileOrEmail(OTP_DESTINATION_TYPE.SMS) : undefined}
                                                >
                                                    Verify
                                                </Button>
                                                : <></>}
                                        </div>

                                    </Form.Item>
                                </Form.Item>
                            </Col>
                            <Col xl={24} lg={24} md={24} sm={24} xs={24} className={"ant-col-xxl-12"}>
                                <Form.Item style={{marginBottom: 8}}>
                                    <Form.Item

                                        label={
                                            <>
                                                {
                                                    isEmailVerified ?
                                                        <>
                                                            Email <span style={{
                                                            color: 'green',
                                                            fontSize: 12,
                                                            paddingLeft: 8
                                                        }}>Verified </span> <CheckCircleOutlined
                                                            style={{color: 'green', fontSize: 10, padding: 3}}/>
                                                        </> :
                                                        <>Email</>
                                                }

                                            </>
                                        }
                                        name="email"
                                        onChange={onChangeEmail}
                                        onKeyPress={Validation.emailFieldValidation}
                                        rules={[
                                            {required: true, message: 'Please enter your email'},
                                            {max: EMAIL_MAX_LENGTH, message: 'The maximum length is 254 characters'},
                                            {
                                                type: 'email',
                                                validator: validateEmail
                                            },

                                        ]}>
                                        <div style={{display: "flex"}}>
                                            <Input size="large" className={"email_input_width"}
                                                   placeholder="Enter email"/>
                                            {!isEmailVerified ?
                                                <Button
                                                    disabled={isEmailVerifyDisabled} type="link"
                                                    onClick={!isEmailVerifyDisabled ? () => generateMobileOrEmail(OTP_DESTINATION_TYPE.EMAIL) : undefined}
                                                    className={"otp_button_verify"}
                                                    style={{width: 80, height: 40, marginLeft: 10}}>
                                                    Verify
                                                </Button> : <></>}
                                        </div>
                                    </Form.Item>
                                    {/*{!isEmailVerified ?*/}
                                    {/*    <Button disabled={isEmailVerifyDisabled} type="link" size="small"*/}
                                    {/*            className="login-form-forgot flex-auto verify-btn"*/}
                                    {/*            onClick={!isEmailVerifyDisabled ? () => generateMobileOrEmail(OTP_DESTINATION_TYPE.EMAIL) : undefined}>*/}
                                    {/*        Verify*/}
                                    {/*    </Button> : <></>}*/}
                                </Form.Item>
                            </Col>
                            <Col lg={24} md={24} xl={24} sm={24} xs={24}>
                                <Form.Item className='userNameFormItem'
                                           label={<><span className='custom-astrix'>*</span> Username</>}
                                           name="userName"
                                           onKeyPress={Validation.alphanumericAndSpecificSpecialCharactersForUsername}
                                           validateTrigger={["onBlur"]}
                                           rules={[
                                               {min: 4, message: 'Minimum of 4 characters are required'},
                                               {max: 20, message: 'The maximum length is 20 characters'},
                                               {pattern: USERNAME_VALIDATION, message: "Please enter valid username"},
                                               {validator: validateUsername}
                                           ]}>
                                    <Input size="large" autoComplete="new-username" placeholder="Enter username"/>
                                </Form.Item>
                            </Col>
                            <Col lg={12} md={12} xl={12} sm={24} xs={24}>
                                <Form.Item
                                    label={<><span className='custom-astrix'>*</span> Password
                                        <Tooltip placement="right" className='password-info-tooltip' title={
                                            <ul style={{padding: '0 10px 0 18px', width: '100%'}}>
                                                <li>Minimum 8 characters</li>
                                                <li>Maximum 20 characters</li>
                                                <li>Should have at least one uppercase</li>
                                                <li>Should have at least one lowercase</li>
                                                <li>Should have at least one numerical value</li>
                                                <li>Should have at least one special character (!, @, #, $, %, ^, &, _,
                                                    or
                                                    *)
                                                </li>
                                            </ul>
                                        }>
                                            <QuestionCircleOutlined
                                                style={{marginLeft: 5, color: '#108ee9', fontSize: 16}}/>
                                        </Tooltip>
                                    </>}
                                    name="password"
                                    rules={[
                                        // {required: true, message: 'Please enter your password'},
                                        {validator: validatePassword},
                                    ]}
                                    onKeyPress={Validation.passwordFieldValidation}
                                    hasFeedback>
                                    <Input.Password size="large" placeholder="Enter password"
                                                    autoComplete="new-password"
                                                    onCopy={preventDefaultEvent}
                                                    onPaste={preventDefaultEvent}/>
                                </Form.Item>
                            </Col>
                            <Col lg={12} md={12} xl={12} sm={24} xs={24}>
                                <Form.Item
                                    label="Confirm Password"
                                    name="confirm"
                                    dependencies={['password']}
                                    rules={
                                        [{required: true, message: 'Please enter your confirm password'},
                                            // {max: 20, message: 'The maximum length is 20 characters'},
                                            // {min: 8, message: 'Minimum of 8 characters are required'},
                                            ({getFieldValue}: any) => ({
                                                validator(_: any, value: any) {
                                                    if (!value || getFieldValue('password') === value) {
                                                        return Promise.resolve();
                                                    }
                                                    return Promise.reject(new Error('Confirm password do not match'));
                                                },
                                            })

                                        ]}
                                    onKeyPress={Validation.passwordFieldValidation}
                                    hasFeedback>
                                    <Input.Password size="large" disabled={isConfirmPasswordDisabled}
                                                    autoComplete="none"
                                                    placeholder="Enter confirm password" onCopy={preventDefaultEvent}
                                                    onPaste={preventDefaultEvent}/>
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Divider/>
                            </Col>
                            <Col lg={24} md={24} xl={24} sm={24} xs={24} className='radio-section'>
                                <p>Which of the following are you using to create this account?</p>
                                <Radio.Group className='radio_group_set' onChange={onChange}
                                             defaultValue={dropdownDto?.value}>
                                    {identificationSourceTypeList.map((data: DropdownListDto) => {
                                        return <Radio value={data.value}>{data.label}</Radio>
                                    })}
                                </Radio.Group>
                            </Col>
                            <Col lg={24} md={24} xl={24} sm={24} xs={24} className='dynamic_field'>
                                <Form.Item
                                    label={dropdownDto?.label.concat(" Number")}
                                    name="identificationSourceValue"
                                    onKeyPress={(dropdownDto?.label === IDENTIFICATION_SOURCE.NIC) ? Validation.nicFieldValidation : Validation.isNumbersAndLetters}
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please enter your '.concat(getPlaceHolderByIdentificationType(dropdownDto?.label)).concat(" number")
                                        },
                                        (dropdownDto?.label !== IDENTIFICATION_SOURCE.NIC) ? {
                                            max: 15,
                                            message: 'The maximum length is 15 characters'
                                        } : {},
                                        (dropdownDto?.label === IDENTIFICATION_SOURCE.NIC) ? {
                                            pattern: NIC_VALIDATION,
                                            message: "Please enter a valid NIC number"
                                        } : {},
                                    ]}>
                                    <Input size="large"
                                           placeholder={"Enter your ".concat(getPlaceHolderByIdentificationType(dropdownDto?.label)).concat(" number")}/>
                                </Form.Item>
                            </Col>
                            <Col lg={24} md={24} xl={24} sm={24} xs={24} className='radio-section'>
                                <Space direction="horizontal">
                                    <p>Do you have a joint account request?</p><Switch size="small"
                                                                                       onChange={onReferenceSwitchChange}
                                                                                       defaultChecked={isReferencePresent}
                                                                                       checkedChildren="Yes"
                                                                                       unCheckedChildren="No"/>
                                </Space>
                                {isReferencePresent ?
                                    <Form.Item
                                        label={<><span className='custom-astrix'>*</span> Reference Number</>}
                                        name="jointReferenceNumber" style={{marginTop: 8}}
                                        onKeyPress={Validation.referenceFieldValidation}
                                        validateTrigger={["onBlur"]}
                                        rules={[
                                            // {max: 6, message: 'The maximum length is 6 characters'},
                                            {validator: validateReference}
                                        ]}>
                                        <Input size="large"
                                               placeholder={"Enter your joint account reference number"}
                                               onInput={(e: any) => e.target.value = ("" + e.target.value).toUpperCase()}/>
                                    </Form.Item>
                                    : <></>}

                            </Col>
                            <Col lg={12} md={12} xl={12} sm={12} xs={12} className='back-btn-container'>
                                <Form.Item className='form-item-btn'>
                                    <Button className='custom-back-btn-primary' type="ghost" onClick={onClickBack}>
                                        Back
                                    </Button>
                                </Form.Item>
                            </Col>
                            <Col lg={12} md={12} xl={12} sm={12} xs={12} className='continue-btn-container'>
                                <Form.Item className='form-item-btn'>
                                    <Button className='custom-btn-primary' type="primary" htmlType="submit"
                                            loading={isBtnContinueLoad}>
                                        Continue
                                    </Button>
                                </Form.Item>
                            </Col>


                        </Row>
                    </Form>
                    <Modal destroyOnClose={true}
                           maskClosable={false}
                           title="Agreement"
                           open={isExistingUserModalOpen}
                           footer={[]}
                           onCancel={handleExistingUserModalCancel}
                           centered
                           className={'agreement-modal'}
                    >

                        <Form
                            className='form-input'
                            layout={"vertical"}
                            initialValues={{remember: true}}
                            form={form}
                            onFinish={onAgree}
                        >
                            <Spin spinning={isAgreementModalLoading}>
                                <Row gutter={[32, 0]}>
                                    <Col lg={24} md={24} xl={24} sm={24} xs={24}>
                                        <span className="agreement-subtitle">Please review and provide your consent to create NDBW Account</span>
                                    </Col>
                                    <Col lg={24} md={24} xl={24} sm={24} xs={24} style={{marginTop: 16}}>
                                        <Form.Item
                                            name={"agreementList"}
                                            label=""
                                            rules={[{validator: validateAgreements}]}
                                        >
                                            <Checkbox.Group style={{width: '50%'}}>
                                                {agreementList && (
                                                    agreementList.map((data) => {
                                                        return (
                                                            <Col lg={12} md={12} xl={12} sm={12} xs={24}>
                                                                <Checkbox value={data.value}
                                                                          style={{paddingBottom: '5'}}>
                                                                    <Button type="link" disabled={false} block
                                                                            onClick={() => showPreview(data.value)}>
                                                                        {data.label}
                                                                    </Button>
                                                                </Checkbox>
                                                            </Col>
                                                        )
                                                    })
                                                )}
                                            </Checkbox.Group>
                                        </Form.Item>
                                        <a hidden ref={btnDownload} href={docURL} download={documentName}></a>
                                    </Col>
                                    <Col span={24}>
                                        <Space style={{float: 'right'}}>
                                            <Form.Item>
                                                <Button className='i-agree-btn' htmlType="submit" type="primary">
                                                    I agree
                                                </Button>
                                            </Form.Item>
                                        </Space>
                                    </Col>

                                </Row>
                            </Spin>

                        </Form>
                    </Modal>
                    <Modal title={modalTitle}
                           open={isModalOpen}
                           destroyOnClose={true}
                           maskClosable={false}
                           closable={false}
                           className='otp-verification-modal'
                           footer={[
                               <Button
                                   // disabled={isResendDisable}
                                   onClick={handleCancel}
                                   className='otp-close-btn'>Close</Button>,
                               <Button type="success" onClick={validateOtp} className='otp-verify-btn'>Verify</Button>,
                           ]}>
                        <p className='otp-sent-info'>Enter the OTP sent
                            to <b>{otpDestination.maskedDestination}</b></p>

                        <Form name="complex-form" ref={otpFormRef}>
                            <Form.Item>

                                <Form.Item
                                    noStyle
                                    name="userOtp"
                                    rules={[{validator: async () => Promise.resolve()}]}
                                >
                                    <InputOTP length={otpData.tokenLength}
                                              inputType={otpData.tokenType.toLowerCase() as otpInputType}
                                              onChange={() => setValue}
                                              value={value}/>
                                </Form.Item>

                                <Typography href="#API">
                                    <p>Didn't you receive the OTP?
                                        <Button type="link" disabled={isResendDisable}
                                                onClick={() => generateMobileOrEmail(otpDestination.type)}>
                                            Resend
                                        </Button>
                                        <span style={{float: 'right', paddingTop: 4}}>{timer}</span>
                                    </p>
                                </Typography>


                            </Form.Item>
                        </Form>

                    </Modal>
                    <Modal
                        className={docType == PREVIEW_DOC_TYPES.PDF ? "modal-custom-bg custom_border" : ""}
                        title={documentName}
                        centered
                        destroyOnClose={true}
                        visible={showModalComp}
                        onCancel={handlePreviewCancel}
                        footer={[
                            <Button onClick={onDownload} style={{background: '#FF7400'}} icon={<DownloadOutlined/>}
                                    type="primary">
                                Download
                            </Button>
                        ]}
                        width={docType == PREVIEW_DOC_TYPES.PDF ? 800 : 400}
                    >
                        <PreviewModalComp docURL={docURL} divHeight={'70vh'}/>
                    </Modal>
                </div>

            </Spin>
        </>


    )

}
export default AccountCredential;

